<app-errorlist></app-errorlist>
@if (roomSelectionService.ngComponentOutletInput$ | async; as input) {
  <div>
    <ng-container *ngComponentOutlet="input.component"></ng-container>
  </div>
}
